import React from 'react';

export function FilePlus({ fill = 'currentColor' }: { fill?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M4 1H8V4C8 5.10313 8.89687 6 10 6H13V14C13 14.5531 12.5531 15 12 15H4C3.44687 15 3 14.5531 3 14V2C3 1.44687 3.44687 1 4 1ZM9 1.41562L12.5844 5H10C9.44688 5 9 4.55312 9 4V1.41562ZM4 0C2.89688 0 2 0.896875 2 2V14C2 15.1031 2.89688 16 4 16H12C13.1031 16 14 15.1031 14 14V5.82812C14 5.29688 13.7906 4.7875 13.4156 4.4125L9.58437 0.584375C9.20937 0.209375 8.70312 0 8.17188 0H4ZM8 8C8 7.72386 7.77614 7.5 7.5 7.5C7.22386 7.5 7 7.72386 7 8V10H5C4.72386 10 4.5 10.2239 4.5 10.5C4.5 10.7761 4.72386 11 5 11H7V13C7 13.2761 7.22386 13.5 7.5 13.5C7.77614 13.5 8 13.2761 8 13V11H10C10.2761 11 10.5 10.7761 10.5 10.5C10.5 10.2239 10.2761 10 10 10H8V8Z"
        fill={fill}
      />
    </svg>
  );
}
